import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { FormattedMessage } from 'react-intl';
import { useModal } from '../../../hooks/useModal';
import { CONTEXT } from '../../../modules/user';
import { IUser } from '../../../modules/user/store';
import DataGridRowMenu from '../../DataGrid/RowMenu';
import RowMenuItem from '../../DataGrid/RowMenuItem';
import UserDeleteModal from '../../UserDeleteModal';
import messages from '../messages';

export interface IRowMenuProps {
  disabled?: boolean;
  onDetail: () => void;
  user: IUser;
}

export function RowMenu({ disabled = false, onDetail, user }: IRowMenuProps) {
  const { Modal: UserDeleteUModal, onOpen: onOpenUserDeleteUModal } = useModal({
    Modal: UserDeleteModal,
  });
  return (
    <>
      <DataGridRowMenu
        menuItems={
          <Box>
            <RowMenuItem
              icon={<AccountCircleIcon />}
              key="view-profile"
              label={<FormattedMessage {...messages.userRowMenuViewProfile} />}
              onClick={onDetail}
            />
            <Divider />
            <RowMenuItem
              colorIcon="error.dark"
              colorText="error.dark"
              disabled={disabled}
              icon={<DeleteIcon />}
              key="user-delete"
              label={<FormattedMessage {...messages.userRowMenuDelete} />}
              onClick={onOpenUserDeleteUModal}
            />
          </Box>
        }
      />
      <UserDeleteUModal context={CONTEXT.COMPANY_ADMINS} user={user} />
    </>
  );
}
